import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Grid,
  Chip,
  Divider,
  IconButton,
  Button,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HomeIcon from '@mui/icons-material/Home';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import blogPosts from '../data/blogPosts';

function BlogPage() {
  const navigate = useNavigate();

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f9f9f9', pb: 8 }}>
      {/* Navigation bar */}
      <Box
        component="nav"
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          borderBottom: '1px solid rgba(0,0,0,0.12)',
          bgcolor: 'background.paper',
          position: 'sticky',
          top: 0,
          zIndex: 100,
          minHeight: 56,
        }}
      >
        <IconButton
          aria-label="Go to home"
          onClick={() => navigate('/')}
          sx={{ minWidth: 48, minHeight: 48 }}
        >
          <HomeIcon />
        </IconButton>
        <Typography variant="body1" sx={{ ml: 1, fontWeight: 600 }}>Earn-E Blog</Typography>
      </Box>
      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1b5e20 0%, #2E7D32 100%)',
          py: 6,
          mb: 6,
          textAlign: 'center',
          color: 'white',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '2.8rem' }, fontWeight: 'bold', mb: 1, color: '#ffffff', textShadow: '0 1px 3px rgba(0,0,0,0.3)' }}>
            Earn-E Blog
          </Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, fontWeight: 'normal', color: 'rgba(255,255,255,0.92)', textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>
            Parenting tips, chore strategies, and ADHD-friendly household advice
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md">
        <Grid container spacing={4}>
          {blogPosts.map((post) => (
            <Grid item xs={12} key={post.id}>
              <Card
                elevation={2}
                sx={{
                  borderRadius: 3,
                  transition: 'box-shadow 0.2s',
                  '&:hover': { boxShadow: 6 },
                }}
              >
                <CardActionArea 
                  onClick={() => navigate(`/blog/${post.slug}`)}
                  aria-label={`Read more about ${post.title}`}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Typography
                      component="h2"
                      variant="h5"
                      sx={{ fontWeight: 'bold', mb: 1.5, color: '#2E7D32' }}
                    >
                      {post.title}
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                      <Typography variant="body2" color="text.secondary">
                        {formatDate(post.date)}
                      </Typography>
                      <Chip
                        icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
                        label={post.readTime}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '0.875rem' }}
                      />
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                      {post.excerpt}
                    </Typography>

                    <Button
                      variant="text"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/blog/${post.slug}`);
                      }}
                      endIcon={<ArrowForward />}
                      aria-label={`Read more about ${post.title}`}
                      sx={{
                        mt: 2,
                        color: '#4CAF50',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontSize: '0.9375rem',
                        minHeight: 48,
                        minWidth: 48,
                        px: 2,
                        py: 1,
                        '&:hover': {
                          bgcolor: 'rgba(76, 175, 80, 0.04)',
                        },
                      }}
                    >
                      Read more
                    </Button>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default BlogPage;
